export const baseAppPath = () => {
  let { pathname } = window.location;
  const officeSharing = /\/oo\/r\/[A-Za-z0-9]+$/;
  const officeTpl = /\/oo\/t\/[A-Za-z0-9_.]+$/;
  const sharing = /\/d\/f\/[A-Za-z0-9]+$/;
  const advSharing = /\/d\/s\/([A-Za-z0-9]+)\/([^/]+)$/;
  const fileRequest = /\/d\/r\/([A-Za-z0-9]+)\/([^/]+)$/;

  if (officeSharing.test(pathname)) {
    pathname = pathname.replace(officeSharing, '');
  } else if (officeTpl.test(pathname)) {
    pathname = pathname.replace(officeTpl, '');
  } else if (sharing.test(pathname)) {
    pathname = pathname.replace(sharing, '');
  } else if (advSharing.test(pathname)) {
    pathname = pathname.replace(advSharing, '');
  } else if (fileRequest.test(pathname)) {
    pathname = pathname.replace(fileRequest, '');
  }

  if (pathname.lastIndexOf('/') === pathname.length - 1) {
    pathname = pathname.slice(0, -1);
  }

  return pathname;
}

export const baseAppURL = () => `${window.location.protocol}//${window.location.host}${baseAppPath()}`